module.exports = __webpack_public_path__ + "static/clemson-u@2x-71baa34ce201d00c34f0937f66e51526.png";